import * as React from 'react'
import * as classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

import * as Style from './style.css'

export interface IProps extends React.ComponentPropsWithoutRef<'p'> {
  color?: 'active'
}

export const LabelArrow = ({ color, ...props }: IProps): JSX.Element => {
  const statusClass = {
    [Style.LabelArrow]: true,
    [Style.LabelArrowActive]: color === 'active',
  }
  return (
    <p className={classNames(statusClass)}>
      {props.children}
      <FontAwesomeIcon icon={faChevronRight} className={Style.LabelArrowIcon} />
    </p>
  )
}

export default LabelArrow
